export function appendQueryParameterToCurrentUrl(key, value)
{
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);

    return url.toString();
}